import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import {
    IBalooMatchData,
    IBalooSettings,
    IBalooSyncLog,
    IBalooGroup,
    IBalooUser,
    IBalooSyncLogListParameter,
} from '@fi-app/external-platform-integration/baloo/baloo';
import { Injectable } from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { FiImageSize } from '@fi-shared/types';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';

@Injectable()
export class BalooService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoadingService: LoadingService,
        private fiPrintDownloadService: FiPrintDownloadService,
    ) {}

    getBalooSettings() {
        return this.fiBackend.fetchData<IBalooSettings>('Integration/Baloo/GetBalooSettings');
    }

    saveSettings(balooSettings: IBalooSettings) {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchDataPost<number>('Integration/Baloo/SaveBalooSettings', balooSettings),
        );
    }

    getMatchData() {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchData<IBalooMatchData>('Integration/Baloo/GetBalooMatchData'),
        );
    }

    getBalooGroups() {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchData<IBalooGroup[]>('Integration/Baloo/GetBalooGroups'),
        );
    }

    getBalooUsers() {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchData<IBalooUser[]>('Integration/Baloo/GetBalooUsers'),
        );
    }

    saveMatches(balooMatchData: IBalooMatchData) {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchDataPost<void>('Integration/Baloo/SaveMatches', balooMatchData),
        );
    }

    syncUnits(isTestMode: boolean) {
        const url = `Integration/Baloo/SyncUnits?isTestMode=${!!isTestMode}`;
        return this.fiBackend.fetchDataPost<IBalooSyncLog>(url);
    }
    syncRoles(isTestMode: boolean) {
        const url = `Integration/Baloo/SyncRoles?isTestMode=${!!isTestMode}`;
        return this.fiBackend.fetchDataPost<IBalooSyncLog>(url);
    }
    syncUsers(isTestMode: boolean) {
        const url = `Integration/Baloo/SyncUsers?isTestMode=${!!isTestMode}`;
        return this.fiBackend.fetchDataPost<IBalooSyncLog>(url);
    }

    getSyncLogListData(parameter: IBalooSyncLogListParameter) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IBalooSyncLog>>(
            'Integration/Baloo/GetSyncLogListData',
            parameter,
        );
    }

    getSyncLog(syncLogId: number) {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchData<IBalooSyncLog>(`Integration/Baloo/GetSyncLog/${syncLogId}`),
        );
    }

    getBalooMagicLink() {
        return this.fiLoadingService.trackPromise(
            this.fiBackend.fetchDataPost<string>('Integration/Baloo/GetMagicLink'),
        );
    }

    setMatchConfirmMessageShown() {
        return this.fiBackend.fetchDataPost<void>('Integration/Baloo/SetMatchConfirmMessageShown');
    }

    getApiResponse() {
        const promise = this.fiPrintDownloadService.downloadBinaryFile('Integration/Baloo/GetApiResponse', {
            fileName: 'baloo_api_response.json',
            size: FiImageSize.Original,
        });
        return promise;
    }

    deleteAllBalooGroups() {
        this.fiLoadingService.trackPromise(
            this.fiBackend.fetchDataPost<void>('Integration/Baloo/DeleteAllBalooGroups'),
        );
    }
}
